import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from 'common/store';

// pre-typed useDispatch to default to the AppDispatch because the default
// dispatch type does not include the thunk middleware types
export const useAppDispatch: () => AppDispatch = useDispatch;

// pre-typed useSelector to avoid having to type (state: RootState every time)
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
